import { createAsyncThunk } from '@reduxjs/toolkit'

import { IEventGood } from 'meta/pages/event'
import { EventController } from 'controller/event'

type Returned = Array<IEventGood>

type Props = {
  codeUrl: string
}

export const getGoods = createAsyncThunk<Returned, Props>('pages/event/goods', async (props) => {
  const { codeUrl } = props
  return EventController.getGoods({ codeUrl })
})
